<template>
  <img src="/logo.jpg" alt="Logo">
</template>
